import {GridFooterContainer, GridFooterContainerProps, gridPageCountSelector, GridPagination, useGridApiContext, useGridSelector} from "@mui/x-data-grid";
import MuiPagination from "@mui/material/Pagination";
import {buttonClasses, Stack} from "@mui/material";
import Button from "@mui/material/Button";
import * as React from "react";
import {TablePaginationProps} from '@mui/material/TablePagination';
import {useGetAuthButtons} from "@/store/menu.c";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import {AuthRouteVO} from "@/service/menu.s";
import {TableFeetType} from "@/widget/ProTable/ProTable";

export interface FooterContainerProps {
    onSearch: (params: any) => void;
    handleToolSelect: (btn: AuthRouteVO) => void;
    code: string
    feet: TableFeetType
}

export const FooterContainer = ({handleToolSelect, code, feet: {leftFunc}, ...rest}: GridFooterContainerProps & FooterContainerProps) => {
    const toolButtons = useGetAuthButtons(code, [1, 6]);
    {
        const apiRef = useGridApiContext();
        const pageCount = useGridSelector(apiRef, gridPageCountSelector);
        const Pagination = ({page, onPageChange, className}: Pick<TablePaginationProps, 'page' | 'onPageChange' | 'className'>) => {
            return <MuiPagination
                color="primary"
                className={className}
                count={pageCount}
                page={page + 1}
                onChange={(event, newPage) => {
                    onPageChange(event as any, newPage - 1);
                }}
            />
        }

        return <GridFooterContainer>
            <Stack justifyContent={'space-between'} width={'100%'} alignContent={'center'} alignItems={'center'} direction="row" spacing={1.3}>
                <Stack alignContent={'center'} pl={1.8} alignItems={'center'} direction="row" spacing={1.3}>
                    {typeof leftFunc == 'function' ? leftFunc(apiRef) :
                        toolButtons?.map((item, index: number) => (
                            <Button
                                variant="outlined"
                                key={index}
                                sx={(theme) => ({
                                    [`& .${buttonClasses.startIcon} > *:nth-of-type(1)`]: {
                                        fontSize: "1.4rem",
                                        width: theme.typography.pxToRem(24),
                                        height: theme.typography.pxToRem(24),
                                    },
                                })}
                                onClick={() => handleToolSelect(item)}
                                startIcon={
                                    item.source == "plus" ? (
                                        <AddOutlinedIcon/>
                                    ) : item.source == 'delete' ? (
                                        <DeleteOutlinedIcon/>
                                    ) : null
                                }
                            >
                                {item.menuName}
                            </Button>
                        ))}
                </Stack>
                <GridPagination ActionsComponent={Pagination} {...rest as any} />
            </Stack>
        </GridFooterContainer>;
    }
}